<template>
    <div
        class="flex-1 cursor-pointer btn-big border flex flex-col items-center select-none border-solid"
        :class="{
            'opacity-25 transition-none': disabled,
            'transition-all duration-200': !disabled,
            'hover:bg-red-light hover:bg-opacity-25': selected && !disabled,
            'shadow-drop border-danger' : selected,
            'selected-btn': !flat && selected,
            'flat-effect': flat && selected,
            'border-grey-light notSelected': !selected,
            'hover:bg-grey hover:bg-opacity-25': !selected && !disabled
        }"
        v-shortkey="hotKey"
        @shortkey="access('shortkey')"
        @click="access('click')"
    >
        <img :src="`${selected && !flat ? imgSelected : imgNotSelected}`" width="40" class="m-2" :class="{ 'mt-3': !helpKey }"/>
        <b :class="{ 'text-white': selected && !flat }"
            class="sm:text-sm md:text-lg">
            {{ label }}
        </b>

        <label v-if="helpKey" class="xs:hidden lg:block text-xs ml-2 cursor-pointer"
            :class="{ 'text-white': selected && !flat }">
            ({{ helpKey }})
        </label>
    </div>
</template>
<script>
export default{
    name: 'payment-button',
    props: {
        selected: Boolean,
        hotKey: Array,
        imgSelected: String,
        imgNotSelected: String,
        label: String,
        disabled: Boolean,
        flat: Boolean
    },
    computed: {
        helpKey () {
            return this.hotKey.reduce((prev, curr) => `${prev.toUpperCase()} + ${curr.toUpperCase()}`)
        }
    },
    methods: {
        access (type) {
            if (!this.disabled)
                this.$emit(type);
        }
    },
}
</script>

<style scoped>
    .notSelected {
        opacity: 0.6;
    }

    .btn-big {
        border-radius: 6px;
    }

    .selected-btn {
        background-color: #EA5455;
    }
    .flat-effect {
        box-shadow: inset 0px 0px 9px 0px rgba(255,0,0,0.35) !important;
    }
</style>